import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DiopazoneLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M8.77 10 6 7l2.77-3M6 7h12m-2.77 3L18 7l-2.77-3" }),
            React.createElement("path", { stroke: "currentColor", d: "M2 2v20M6 16v6M10 16v6M14 16v6M18 16v6M22 2v20" })));
}
const DiopazoneLightCustom = forwardRef(_DiopazoneLightCustom);
export { DiopazoneLightCustom };
